import React, { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from "./theme";
import store from "./redux/store";

import Main from "./components/Main/Main";
import WaitCursor from "./components/common/WaitCursor";

const App = () => {
    return (
        <ThemeProvider theme={theme} >
            <ReduxProvider store={store}>
                <Router>
                    <Suspense fallback={<WaitCursor />}>
                        <Main />
                    </Suspense>
                </Router>
            </ReduxProvider>
        </ThemeProvider>
    );
};

export default App;
